import { render, staticRenderFns } from "./LabelWrapper.vue?vue&type=template&id=105ff342&scoped=true&"
import script from "./LabelWrapper.vue?vue&type=script&lang=js&"
export * from "./LabelWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LabelWrapper.vue?vue&type=style&index=0&id=105ff342&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ff342",
  null
  
)

export default component.exports